/**
 * Shallow equality check for two values. Returns true when both are the same
 * reference, or are objects with the same own enumerable keys whose values are
 * each `Object.is`-equal. Replaces the `shallowequal` package (we only ever used
 * its default two-argument form).
 */
export default function shallowEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) {
    return true;
  }

  if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
    return false;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  return keysA.every(
    (key) =>
      Object.prototype.hasOwnProperty.call(b, key) &&
      Object.is((a as Record<string, unknown>)[key], (b as Record<string, unknown>)[key])
  );
}
